export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 1092;
export const BREAKPOINT_XL = 1300;
